import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '../../../shared';

@Component({
  selector: 'app-compose-email-dialog',
  templateUrl: './compose-email-dialog.component.html',
  styleUrls: ['./compose-email-dialog.component.scss']
})
export class ComposeEmailDialogComponent implements OnInit {
  recipients: string[] = ['me', 'you', 'us'];
  sender: User;
  emailForm: FormGroup;
  senderControl = new FormControl({value: '', disabled: true});
  recipientsControl = new FormControl({value: '', disabled: true});
  subjectControl = new FormControl('', [Validators.required]);
  bodyControl = new FormControl('', [Validators.required]);

  @Output() onSendEmail = new EventEmitter<any>();
  @Output() onCancelEmail = new EventEmitter<any>();
  @Output() onuserNullError = new EventEmitter<string>();

  NULL_USER_ERROR_MESSAGE = 'No authenticated user detected';

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<ComposeEmailDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.recipients = (data) ? data.recipients : [];
    this.sender = (data) ? data.user : null;

    if (this.sender === null) {
      this.onuserNullError.emit(this.NULL_USER_ERROR_MESSAGE);
    }

    const flatEmailAddresses = this.recipients.join('; ');
    this.recipientsControl.patchValue(flatEmailAddresses);
    this.senderControl.patchValue(`${this.sender.name}<${this.sender.email}>`);
  }

  ngOnInit() {
    this.emailForm = this.formBuilder.group({
      senderControl: this.senderControl,
      recipientsControl: this.recipientsControl,
      subjectControl: this.subjectControl,
      bodyControl: this.bodyControl
    });
  }

  isCompletelyFilledOut() {
    return this.emailForm.valid;
  }

  cancelEmail() {
    this.onCancelEmail.emit();
    this.dialogRef.close();
  }

  submitForm() {
    const result = {
      from: this.senderControl.value,
      recipients: this.recipients.join('; '),
      subject: this.subjectControl.value,
      message: this.bodyControl.value
    };

    this.onSendEmail.emit(result);
    this.dialogRef.close(result);
  }

  tinyMceInit = {
    height: 200,
    menubar: false,
    plugins: 'lists link preview wordcount visualblocks',
    toolbar:
      'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
  }
}
